export type PromptPlacement = "topRight" | "bottomCenter";

export interface InstallPromptPlatform {
  isAndroid: boolean;
  isIos: boolean;
  placement: PromptPlacement;
}

function isIosBrowser(userAgent: string): boolean {
  const platform = navigator.platform || "";
  const hasTouch = navigator.maxTouchPoints > 1;

  return (
    /iPad|iPhone|iPod/.test(userAgent) || (platform === "MacIntel" && hasTouch)
  );
}

function isAndroidBrowser(userAgent: string): boolean {
  return /Android/i.test(userAgent);
}

function isYandexBrowser(userAgent: string): boolean {
  return /YaBrowser|YaApp_Android/i.test(userAgent);
}

export function getInstallPromptPlatform(): InstallPromptPlatform | null {
  if (typeof window === "undefined") return null;

  const { userAgent } = navigator;
  const isAndroid = isAndroidBrowser(userAgent);
  const isIos = isIosBrowser(userAgent);

  if (!isAndroid && !isIos) return null;

  return {
    isAndroid,
    isIos,
    placement:
      isIos || (isAndroid && isYandexBrowser(userAgent))
        ? "bottomCenter"
        : "topRight",
  };
}

export function isStandalonePwa(): boolean {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    Boolean((navigator as Navigator & { standalone?: boolean }).standalone)
  );
}
